<style scoped>
.fill-height {
	height: calc(100vh - 74px);
	overflow-y: auto;
	overflow-x: hidden;
}
.channel-card {
	cursor: pointer;
}
.channel-card:hover {
	opacity: 0.8;
}
</style>

<template>
	<mu-container>
		<div v-if="$store.state.flag.fetchedSettings">
			<div class="text-align-center">
				<mu-button v-if="!isPreview" color="primary" @click="flagDialogCreateCourse = true"> <mu-icon value="add" /> {{ $t("button.add") + $t("space") + $t("terms.channel") }} </mu-button>
			</div>
			<h2>{{ $t("Home.public") }}</h2>
			<transition name="fade" mode="out-in">
				<div v-if="flagFetchedChannels && publicChannels.length > 0">
					<transition name="slide-fade" mode="out-in">
						<transition-group name="list-complete" tag="mu-row" v-if="publicChannels.length" gutter>
							<div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 list-complete-item" v-for="(channel, index) in publicChannels" :key="index">
								<channel-card class="full-width channel-card" :channel="channel" @click.native="onClickChannel(channel._id)" />
							</div>
						</transition-group>
					</transition>
				</div>
			</transition>
			<h2>{{ $t("Home." + (isTeacher ? "listTeacher" : "listStudent")) }}</h2>
			<transition name="fade" mode="out-in">
				<div v-if="flagFetchedChannels && computedChannels.length > 0">
					<transition name="slide-fade" mode="out-in">
						<transition-group name="list-complete" tag="mu-row" v-if="computedChannels.length" gutter>
							<div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 list-complete-item" v-for="(channel, index) in computedChannels" :key="index">
								<channel-card class="full-width channel-card" :channel="channel" @click.native="onClickChannel(channel._id)" />
							</div>
						</transition-group>
					</transition>
				</div>
			</transition>
			<Empty :condition="computedChannels.length === 0" message="Course is not ready yet." class="fill-height" />
			<mu-dialog :title="$t('button.add') + $t('space') + $t('terms.channel')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreateCourse">
				<mu-form :model="channel" label-width="500">
					<mu-form-item prop="input" :label="$t('Home.channel.name')">
						<mu-text-field v-model="modelName"></mu-text-field>
					</mu-form-item>
					<mu-form-item prop="input" :label="$t('Home.channel.alias')">
						<mu-text-field v-model="modelAlias"></mu-text-field>
					</mu-form-item>
					<mu-form-item prop="input" :label="$t('Home.channel.public.display')">
						<mu-radio v-model="modelPublic" :value="false" :label="$t('Home.channel.public.no')"></mu-radio>
						<mu-radio v-model="modelPublic" :value="true" :label="$t('Home.channel.public.yes')"></mu-radio>
					</mu-form-item>
				</mu-form>
				<mu-button slot="actions" flat color="primary" @click="onClickCancelCourse"><mu-icon value="close"></mu-icon> {{ $t("prompt.cancel") }}</mu-button>
				<mu-button slot="actions" flat color="primary" @click="onCreateChannel('course')" :disabled="isNameEmpty"><mu-icon value="check"></mu-icon> {{ $t("prompt.confirm") }}</mu-button>
			</mu-dialog>
		</div>
	</mu-container>
</template>

<script>
// Components
import ChannelCard from "@/components/Channel/Card/Main.vue";
import Empty from "@/components/Empty.vue";

// Library
import axios from "axios";

import langEn from "./lang/en.json";
import langZh from "./lang/zh.json";

export default {
	name: "HomePage",
	components: {
		ChannelCard,
		Empty,
	},
	data() {
		return {
			loading: null,

			// Object
			channels: [], // Channels list
			enrollments: [],
			admins: [],

			// Flag
			flagFetchedChannels: false, // Boolean variable for status of fetched channels
			flagDialogCreateCourse: false, // Boolean variable for status of create course channel dialog
			flagDialogEdit: false, // Boolean variable for status of edit channel dialog
			flagDialogDelete: false, // Boolean variable for status of delete channel dialog

			// Model
			channel: {},
			modelName: "", // Bind with name input
			modelAlias: "",
			modelPublic: false,
		};
	},
	computed: {
		// Class
		computedChannels() {
			return this.channels.filter((i) => i.public !== true);
		},
		publicChannels() {
			return this.channels.filter((i) => i.public === true);
		},

		// Flag
		isNameEmpty() {
			if (this.modelName === "") {
				return true;
			} else {
				return false;
			}
		},
		isTeacher() {
			return this.$store.getters.isTeacher;
		},
		isPersonalChannelExist() {
			var flag = false;
			this.channels.forEach((item) => {
				if (item.type === "personal" && item.creator_id === this.$store.state.auth.user._id) flag = true;
			});
			return flag;
		},

		// Store
		triggerRefresh() {
			return this.$store.getters.triggerRefresh;
		},
		authorized() {
			return this.$store.state.auth.authorized;
		},
		isPreview() {
			if (this.$store.getters.previewMode) {
				return true;
			} else {
				return false;
			}
		},
	},
	watch: {
		triggerRefresh() {
			this.fetchChannels();
		},
	},
	created() {
		if (this.authorized) this.fetchChannels();
		this.$i18n.add("en", langEn); // Add English Translation
		this.$i18n.add("zh", langZh); // Add Traditional Chinese Translation
	},
	methods: {
		// Fetch
		fetchChannels() {
			axios
				.get(this.$store.getters.urlApi + "channel/list", {
					headers: {
						token: this.$store.state.auth.token,
					},
				})
				.then((response) => {
					this.channels = response.data.data.channels;
//					console.log(response.data.data.channels);
					if(this.channels.length > 0){

						this.channels.sort((a,b)=>{
							if((new Date(a.created_at)).getTime() > (new Date(b.created_at)).getTime()){
								return -1;
							}else if((new Date(a.created_at)).getTime() < (new Date(b.created_at)).getTime()){
								return 1;
							}
							return 0;
						})
					}					
					this.flagFetchedChannels = true;
				});
		},

		// Event
		onClickCancelCourse() {
			this.flagDialogCreateCourse = false; // Only can create course in this stage
		},
		onClickCreatePersonal() {
			this.flagDialogCreatePersonal = true;
			this.modelName = "";
		},
		onClickCreateCourse() {
			this.flagDialogCreateCourse = true;

			this.modelName = "";
		},
		onCreateChannel(type) {
			this.flagDialogCreateCourse = false;
			axios
				.post(
					this.$store.getters.urlApi + "channel",
					{
						name: this.modelName,
						type: type,
						visible: true,
						alias: this.modelAlias,
					},
					{
						headers: {
							token: this.$store.state.auth.token,
							"content-type": "application/json",
						},
					}
				)
				.then(() => {
					this.fetchChannels();
					this.modelName = "";
					this.$toast.success(this.$t("toast.create"));
				});
		},
		onClickChannel(id) {
			this.$router.push({
				name: "Channel",
				params: {
					channelId: id,
				},
			});
		},
	},
};
</script>
